<template>
  <institution-form :institution="newIns"></institution-form>
</template>

<script>
import InstitutionForm from './institutionForm'
import {Institution} from '../../../object'

export default {
  name: 'NewInstitution',
  components: {InstitutionForm},
  data: () => ({
    newIns: new Institution()
  })
}
</script>

<style scoped>

</style>
